import { getInstanceId } from '@va/dashboard/selectors/app';
import { CodeEditorWithCopyBtn } from '@va/dashboard/ui/components';
import { InfoIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { CustomDomainType } from '@va/shared/api/custom-domains';
import { useListWebsiteDomainsByType } from '@va/shared/api/custom-domains/custom-domains.api.hooks';
import { CheckMarkWithFilledBackground } from '@va/svg-visa-icons';
import { Chip, fontWeights, Paragraph } from '@va/ui/design-system';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

type TrackingCodeSectionProps = {
  description: string;
  trackingCode: string;
  chips?: { label: string; tooltip?: string }[];
  allowCustomDomain?: boolean;
};

export const TrackingCodeSection = ({
  description,
  trackingCode,
  chips,
  allowCustomDomain,
}: TrackingCodeSectionProps) => {
  return (
    <div className='flex flex-col gap-2 bg-black-lighter-05 rounded-t-24 rounded-b-36px p-18px'>
      <div className='px-1.5'>
        <Paragraph weight={fontWeights.medium} colorClassName={'text-gray-charcoal'} className={'leading-24'}>
          {description}
        </Paragraph>
      </div>
      <CodeEditorWithCopyBtn editorClassName='bg-white!' code={trackingCode} />
      {allowCustomDomain && <CustomDomainNotification className='bg-white!' />}
    </div>
  );
};

export const CustomDomainNotification = ({ className }: { className?: string }) => {
  const websiteId = useSelector(getInstanceId);

  const translate = useTranslate();

  const { data } = useListWebsiteDomainsByType({ type: CustomDomainType.trackingCode, websiteId: websiteId });

  if (!data?.active) return null;
  return (
    <Chip
      className={classNames(className, 'rounded-15! p-1.5! pr-3! md:overflow-hidden')}
      icon={<InfoIcon className='w-18px h-18px' color='#FCC573' />}
      tooltip={translate('standalone.customDomains.trackingCode.useUpdatedSnippetNotificationTooltip')}
    >
      {translate('standalone.customDomains.trackingCode.useUpdatedSnippetNotification')}
    </Chip>
  );
};
